import { render, staticRenderFns } from "./BaseFileUploader.vue?vue&type=template&id=59231264&"
import script from "./BaseFileUploader.vue?vue&type=script&lang=js&"
export * from "./BaseFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports